import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/adminNotificationSlice";
import adminNotificationApis from "src/api/adminNotification";
import { common } from "src/types";
import { constants } from "src/constants/common";

function* GetNotificationListSaga({
  payload,
}: ReturnType<typeof actions.getNotificationListRequest> & {
  payload: { page?: number; limit: number; unreadOnly?: boolean };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      adminNotificationApis.getNotificationList,
      payload
    );
    yield put(actions.getNotificationListSuccess(response));
  } catch (error) {
    yield put(
      actions.getNotificationListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* GetUnreadCountSaga() {
  try {
    const response: common.ResponseGenerator = yield call(
      adminNotificationApis.getUnreadCount
    );
    yield put(actions.getUnreadCountSuccess(response?.data?.count || 0));
  } catch (error) {
    yield put(
      actions.getUnreadCountError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* MarkNotificationReadSaga({
  payload,
}: ReturnType<typeof actions.markNotificationReadRequest> & {
  payload: string;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      adminNotificationApis.markNotificationRead,
      payload
    );
    yield put(actions.markNotificationReadSuccess(response?.data));
    yield put(actions.getUnreadCountRequest());
  } catch (error) {
    yield put(
      actions.markNotificationReadError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* MarkAllNotificationsReadSaga() {
  try {
    const response: common.ResponseGenerator = yield call(
      adminNotificationApis.markAllNotificationsRead
    );
    yield put(actions.markAllNotificationsReadSuccess(response));
    yield put(actions.getUnreadCountRequest());
  } catch (error) {
    yield put(
      actions.markAllNotificationsReadError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* adminNotificationSaga() {
  yield all([
    takeEvery(actions.getNotificationListRequest, GetNotificationListSaga),
    takeEvery(actions.getUnreadCountRequest, GetUnreadCountSaga),
    takeEvery(actions.markNotificationReadRequest, MarkNotificationReadSaga),
    takeEvery(
      actions.markAllNotificationsReadRequest,
      MarkAllNotificationsReadSaga
    ),
  ]);
}
